import type { CREATE_ENROLLMENT_vars } from "graphql/mutation/createEnrollment";

import { Sentry, isSentryEnabled } from "./sentry";

type Phase = "prepare" | "graphql" | "mutation_response" | "network";

export function reportCreateEnrollmentFailure(params: {
  phase: Phase;
  error?: unknown;
  graphqlMessages?: string[];
  mutationMessage?: string | null;
  variables?: CREATE_ENROLLMENT_vars;
}): void {
  if (!isSentryEnabled()) {
    return;
  }

  const text =
    params.error instanceof Error
      ? params.error.message
      : params.graphqlMessages?.join("; ") ??
        params.mutationMessage ??
        "Unknown error";

  Sentry.withScope((scope) => {
    scope.setTag("flow", "create_enrollment");
    scope.setTag("phase", params.phase);
    scope.setExtra("errorMessage", text);
    if (params.variables) {
      scope.setContext(
        "createEnrollmentVariables",
        params.variables as unknown as Record<string, unknown>,
      );
    }

    if (params.error instanceof Error) {
      Sentry.captureException(params.error);
      return;
    }

    Sentry.captureMessage(`createEnrollment (${params.phase}): ${text}`, {
      level: "error",
    });
  });
}
